export default __webpack_public_path__ + "static/groups-hero-1a-826e13d202f7eb3e4d50f7f2571924fa.jpg";